import { axios } from '@/utils/http'
import { Captcha, LoginToken } from '@/models/session'
import { Tokens } from '@/models/session/token'

/**
 * 登入
 * @param token 用户名密码
 */
export async function post(token: LoginToken) {
  const { data } = await axios.post(`session`, token)
  return data as Tokens
}

/**
 * 刷新验证码
 */
export async function get() {
  const { data } = await axios.get(`session`)
  return data as Captcha
}

/**
 * 登出
 */
export async function del() {
  await axios.delete(`session`)
}
